import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { ViewPageLayout } from 'pages/settings/pages/billing/layout/ViewPageLayout/ViewPageLayout'
import { AddSubscriptionAccessLayout } from 'pages/settings/pages/billing/layout/AddSubscriptionAccessLayout'
import { BillingViewProvider } from 'pages/settings/pages/billing/context/billingViewContext'
import { UpgradePage } from 'pages/settings/pages/billing/pages/upgrade/ui/upgradePage'

export const AddSubscriptionRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route element={<AddSubscriptionAccessLayout />}>
        <Route
          index
          element={
            <BillingViewProvider>
              <ViewPageLayout>
                <UpgradePage />
              </ViewPageLayout>
            </BillingViewProvider>
          }
        />
      </Route>
    </RoutesWithNotFound>
  )
})
